import { request } from "./type";
const router = "permissions";

// 取得所有權限角色
const getRolePermissionsByBrand = (token, branchId) => {
  return request("get", `${router}/getRolePermissions?branchId=${branchId}`, token);
};
// 更新角色權限
const updateRolePermissions = (token, data) => {
  return request("put", `${router}/updatePermissions`, token, data);
};
// 新增 角色
const addPermissionRole = (token, data) => {
  return request("post", `${router}/addBranchRoles`, token, data);
};
// 刪除 角色
const deletePermissionRole = (token, roleId, branchId) => {
  return request("delete", `${router}/deletePermissions?roleId=${roleId}&branchId=${branchId}`, token);
};
// 取得可匯入的預設角色列表
const getImportableRoles = (token) => {
  return request("get", `${router}/importableRoles`, token);
};
// 匯入預設角色到指定分店
const importPermissionRoles = (token, data) => {
  return request("post", `${router}/importRoles`, token, data);
};
// 取得所有分店及權限角色
const getBranchAndPermissionByToken = (token) => {
  return request("get", `${router}/branchesAndPermissions`, token);
}

// 取得員工可訪問的倉庫列表
// const getAccessibleWarehousesByEmployeeId = (token, employeeId) => {
//   return request("get", `${router}/accessible-warehouses/${employeeId}`, token);
// };

export {
  addPermissionRole,
  deletePermissionRole,
  getImportableRoles,
  importPermissionRoles,
  getRolePermissionsByBrand,
  updateRolePermissions,
  getBranchAndPermissionByToken,
  // getAccessibleWarehousesByEmployeeId
}
